import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import { setPharmaorderSorting } from 'store/slice/PharmaSlice';
import { use } from 'react';


export default function PharmaorderListTableHeader(){
    const dispatch = useDispatch();
    const {mobileView} = useSelector((state) => state.menu);
    const {sorting} = useSelector((state) => state.pharmaslice.pharmaorderDashboard);

    useEffect(() => {
      dispatch(setPharmaorderSorting({'column':'orderid', 'asc':false}));
    }, []);


    return (
      <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%', padding: 1, backgroundColor: 'primary.lighter' }}>
        {/* <HEADER - CELLS/> */}
        <Grid
          item
          lg={1}
          xs={2}
          sx={{ cursor: 'pointer' }}
          onClick={() => dispatch(setPharmaorderSorting({'column': 'orderid', 'asc': !sorting.asc}))}
        >
          <Typography variant="h5">{mobileView ? '#' : 'Order Id'}</Typography>
        </Grid>
        <Grid
          item
          lg={3}
          xs={4}
          sx={{ cursor: 'pointer' }}
          onClick={() => dispatch(setPharmaorderSorting({'column':'partyname', 'asc': !sorting.asc}))}
        >
          <Typography variant="h5">Party Name</Typography>
        </Grid>
        {!mobileView ? (
          <>
            <Grid
              item
              lg={1}
              xs={1}
              sx={{ cursor: 'pointer' }}
              onClick={() => dispatch(setPharmaorderSorting({'column':'executivename', 'asc': !sorting.asc}))}
            >
              <Typography variant="h5">Executive</Typography>
            </Grid>
            <Grid
              item
              lg={1}
              xs={2}
              //sx={{ cursor: 'pointer' }}
              
            >
              <Typography variant="h5">Value</Typography>
            </Grid>
          </>
        ) : null}
        <Grid
          item
          lg={2}
          xs={6}
          sx={{ cursor: 'pointer' }}
          onClick={() => dispatch(setPharmaorderSorting({'column':'orderstatus', 'asc': !sorting.asc}))}
        >
          <Typography variant="h5">Status</Typography>
        </Grid>
        <Grid
          item
          lg={1}
          xs={6}
          sx={{ cursor: 'pointer' }}
          onClick={() => dispatch(setPharmaorderSorting({'column':'creationTimestamp', 'asc': !sorting.asc}))}
        >
          <Typography variant="h5">C-Date</Typography>
        </Grid>
        <Grid
          item
          lg={1}
          xs={6}
          sx={{ cursor: 'pointer' }}
          onClick={() => dispatch(setPharmaorderSorting({'column':'submitdate', 'asc': !sorting.asc}))}
        >
          <Typography variant="h5">S-Date</Typography>
        </Grid>
      </Grid>
    )
}